import { render, staticRenderFns } from "./EditPdfDialog.vue?vue&type=template&id=b2d66b68&"
import script from "./EditPdfDialog.vue?vue&type=script&lang=ts&"
export * from "./EditPdfDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports